/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addAttribute } from '../fn/attribute-api/add-attribute';
import { AddAttribute$Params } from '../fn/attribute-api/add-attribute';
import { ApiResponseAttribute } from '../models/api-response-attribute';
import { ApiResponseListAttribute } from '../models/api-response-list-attribute';
import { ApiResponseVoid } from '../models/api-response-void';
import { attachment } from '../fn/attribute-api/attachment';
import { Attachment$Params } from '../fn/attribute-api/attachment';
import { deleteAttribute } from '../fn/attribute-api/delete-attribute';
import { DeleteAttribute$Params } from '../fn/attribute-api/delete-attribute';
import { listAllAttributes } from '../fn/attribute-api/list-all-attributes';
import { ListAllAttributes$Params } from '../fn/attribute-api/list-all-attributes';

@Injectable({ providedIn: 'root' })
export class AttributeApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `deleteAttribute()` */
  static readonly DeleteAttributePath = '/v1/api/ui/attribute/delete/{attributeId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteAttribute()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAttribute$Response(params: DeleteAttribute$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseVoid>> {
    return deleteAttribute(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteAttribute$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAttribute(params: DeleteAttribute$Params, context?: HttpContext): Observable<ApiResponseVoid> {
    return this.deleteAttribute$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseVoid>): ApiResponseVoid => r.body)
    );
  }

  /** Path part for operation `attachment()` */
  static readonly AttachmentPath = '/v1/api/ui/attribute/attachement';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `attachment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  attachment$Response(params: Attachment$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseVoid>> {
    return attachment(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `attachment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  attachment(params: Attachment$Params, context?: HttpContext): Observable<ApiResponseVoid> {
    return this.attachment$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseVoid>): ApiResponseVoid => r.body)
    );
  }

  /** Path part for operation `addAttribute()` */
  static readonly AddAttributePath = '/v1/api/ui/attribute/add';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addAttribute()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addAttribute$Response(params: AddAttribute$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseAttribute>> {
    return addAttribute(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addAttribute$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addAttribute(params: AddAttribute$Params, context?: HttpContext): Observable<ApiResponseAttribute> {
    return this.addAttribute$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseAttribute>): ApiResponseAttribute => r.body)
    );
  }

  /** Path part for operation `listAllAttributes()` */
  static readonly ListAllAttributesPath = '/v1/api/ui/attribute/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listAllAttributes()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAllAttributes$Response(params: ListAllAttributes$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListAttribute>> {
    return listAllAttributes(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listAllAttributes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAllAttributes(params: ListAllAttributes$Params, context?: HttpContext): Observable<ApiResponseListAttribute> {
    return this.listAllAttributes$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListAttribute>): ApiResponseListAttribute => r.body)
    );
  }

}
